<template>
    <div class="qty-box d-flex num">
        <span
        :disabled="value <= min"
        @click="checkValue(--value)"
        class="qty-subtract"
        >
<!--            <span class="toltiptext" v-if="value = min">حداقل تعداد مجاز {{min}} می باشد</span>-->
            <i class="fa fa-minus"></i>
        </span>

        <input
        type="number"
        :style="`width :${width}`"
        @keyup.enter="checkValue(value)"
        @blur="checkValue(value)"
        @input="$emit('input',value)"
        v-model.number="value"
        style="min-width: 18.2px;" name="qty" >

        <span
        :disabled="value >= max"
        @click="checkValue(++value)"
        class="qty-add"
        >
<!--            <span class="toltiptext" v-if="value == max">حداکثر تعداد مجاز {{max}} می باشد</span>-->
            <i class="fa fa-plus"></i>
        </span>
    </div>
</template>

<script>
    export default {
        name: "numberCounter",
        props:{
            min: Number,
            max: Number,
            number: Number,
        },
        data(){
            return{
                value : 0,
            }
        },
        methods:{
            notif(flag){
                let text =''
                if (flag === 'min')
                    text = ` حداقل تعداد مجاز${this.min}عدد است `
                else
                    text = ` حداکثر تعداد مجاز${this.max}عدد است `

                this.$vs.notify({
                    title: 'خطا',
                    text,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                })
            },
            checkValue(value){
                if(value > this.max)
                {
                    this.value = this.max
                    setTimeout(()=>{
                        this.notif('max')
                    },100)
                    this.$emit('input',this.max)
                }
                else if(value < this.min){
                    this.value = this.min
                    setTimeout(()=>{
                        this.notif('min')
                    },100)
                    this.$emit('input',this.min)
                }
                else
                    this.$emit('input',value)
            }
        },
        watch: {
            value(value){
                this.checkValue(value)
            }
        },
        computed: {
            width(){
                return `${(this.value.toString().length * 7)+31}px`
            }
        },
        created() {
            this.value = this.number
        }
    }
</script>
